import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import SkillForm from '../components/SkillForm';
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';
import { REACT_ICONS } from '../utils/reactIcons';
import '../components/skills.css';

const SkillsPage = () => {
  const [skills, setSkills] = useState([]);
  const [editingSkill, setEditingSkill] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  useEffect(() => {
    apiClient.get('/skills').then(res => setSkills(res.data || []));
  }, []);

  const saveSkill = async (data) => {
    const payload = { ...data, level: data.level * 20 };

    if (editingSkill) {
      const res = await apiClient.put(`/skills/${editingSkill.id}`, payload);
      setSkills(skills.map(s => s.id === editingSkill.id ? res.data : s));
    } else {
      const res = await apiClient.post('/skills', payload);
      setSkills([...skills, res.data]);
    }

    setShowModal(false);
  };

  const confirmDelete = async () => {
    await apiClient.delete(`/skills/${deleteTarget.id}`);
    setSkills(skills.filter(s => s.id !== deleteTarget.id));
    setDeleteTarget(null);
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Skills</h2>
        <button className="btn-primary" onClick={() => setShowModal(true)}>
          + Add Skill
        </button>
      </div>

      <table className="skill-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Icon</th>
            <th>Level</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {skills.map(skill => {
            const Icon = REACT_ICONS[skill.icon] || REACT_ICONS.SiReact;
            return (
              <tr key={skill.id}>
                <td>{skill.name}</td>
                <td>{skill.category}</td>
                <td><Icon size={18} /></td>
                <td>{Math.round(skill.level / 20)}/5</td>
                <td className="actions">
                  <button onClick={() => { setEditingSkill(skill); setShowModal(true); }}>
                    Edit
                  </button>
                  <button className="danger" onClick={() => setDeleteTarget(skill)}>
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {showModal && (
        <SkillForm
          skill={editingSkill}
          onSave={saveSkill}
          onCancel={() => setShowModal(false)}
        />
      )}

      <ConfirmDeleteModal
        open={!!deleteTarget}
        title="Delete Skill"
        message={`Delete "${deleteTarget?.name}" permanently?`}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </div>
  );
};

export default SkillsPage;
